module.exports = __webpack_public_path__ + "img/mehmet-kirci-start.e3d061de.jpg";